'use client'

import { ReactNode, useCallback, useMemo, useState } from 'react'

import Context, { SortContextType } from './SortContext'
import { transformObjectToSortedArray } from './utils'

type Props = {
  children: ReactNode
}

const SortProvider = ({ children }: Props) => {
  const [indexes, setIndexes] = useState<SortContextType['indexes']>({})

  const addItem = useCallback(
    (id: string, index: number) => setIndexes(prevState => ({ ...prevState, [id]: index })),
    [],
  )

  const removeItem = useCallback(
    (id: string) => setIndexes(({ [id]: _, ...prevState }) => prevState),
    [],
  )

  const value = useMemo(
    () => ({ indexes, items: transformObjectToSortedArray(indexes), addItem, removeItem }),
    [addItem, indexes, removeItem],
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export default SortProvider
